export const hasGtm = (window: Window) => Boolean((window as any).dataLayer);
